import React, { useRef, useState, useCallback } from "react";
import AliceCarousel from "react-alice-carousel";
import "react-alice-carousel/lib/alice-carousel.css";
import "./VideoCarousel.css";

const VideoCarousel = ({ videos }) => {
  const responsive = {
    0: { items: 1 },
    568: { items: 2 },
    1024: { items: 3 },
  };

  const videoRefs = useRef([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [thumbnailUrls, setThumbnailUrls] = useState(videos.map((video) => video.thumbnail || ""));

  const onItemChange = useCallback((index) => {
    if (videoRefs.current[index] && videoRefs.current[index] !== videoRefs.current[currentIndex]) {
      if (videoRefs.current[currentIndex]) {
        videoRefs.current[currentIndex].pause();
      }

      setCurrentIndex(index);
    }
  }, [currentIndex]);

  return (
    <AliceCarousel
      mouseTracking
      responsive={responsive}
      onSlideChanged={onItemChange}
    >
      {videos.map((video, index) => (
        <div key={index} className="video-carousel-item">
          <video
            controls
            ref={(ref) => (videoRefs.current[index] = ref)}
            poster={video.thumbnail || ""}
          >
            <source src={video.src} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>
      ))}
    </AliceCarousel>
  );
};

export default VideoCarousel;

